// CustomerActivity.js

import React, { useContext, useState, useEffect } from 'react'
import { useFormik } from 'formik'

import Layout from '@/product/components/templates/Layout'
import CustomTable from '@/product/components/molecules/CustomTable'
import CustomSearch from '@/product/components/molecules/CustomSearch'

import SettingContext from '@/product/context/setting/settingContext'

const CustomerActivity = () => {
    const settingcontext = useContext(SettingContext)
    const today = new Date()
    const currentYear = today.getFullYear()
    const {
        searchTableFetch,
        search_fetch_data,
        responseStatus: responseStatusSetting,
        clearResponse: clearResponseCommuncation,
    } = settingcontext
    const [changeStatus, setChangeStatus] = useState(false)
    const changeChangeStatus = () => {
        setChangeStatus(!changeStatus)
    }

    const [manage, setManage] = React.useState({
        popup: false,
        status: 'new',
        id: 0,
    })

    const [allData, setAllData] = useState({})
    const [isLoading, setIsLoading] = useState(false)
    const [tableBody, setTableBody] = useState([])

    const formikFetch = useFormik({
        initialValues: {
            page: 1,
            limit: 20,
            order: 'desc',
            orderby: 'bj.id',
            primaryTable: 'buyer_journey',
            timeConditionField: 'bj.created_at',
            search: 'within',
            within: 'month',
            start_date: `01-01-${currentYear}`,
            end_date: `12-31-${currentYear}`,
            select_type: 'yearly',
            year: currentYear,
            tableJoins: [
                {
                    baseTable: 'users',
                    joinType: 'left',
                    baseJoinField: 'id',
                    connectJoinField: 'user_id',
                },
            ],
            filters: {
                journey: {
                    type: 'notnull',
                    value: '',
                    field: 'bj.description',
                },
                users_first_name: {
                    type: 'like',
                    value: '',
                    field: 'u.first_name',
                },
                users_last_name: {
                    type: 'like',
                    value: '',
                    field: 'u.last_name',
                },
                users_location: {
                    type: 'like',
                    value: '',
                    field: 'bj.user_location',
                },
                users_email: {
                    type: 'like',
                    value: '',
                    field: 'u.email',
                },
                created_at_start: {
                    type: 'gte',
                    value: '',
                    field: 'bj.created_at',
                },
                description: {
                    type: 'singleSelect',
                    value: '',
                    field: 'bj.description',
                },
                ip_address: {
                    type: 'like',
                    value: '',
                    field: 'bj.ip_address',
                },
                browser_name: {
                    type: 'like',
                    value: '',
                    field: 'bj.browser_name',
                },
            },
        },
        onSubmit: (values) => {
            searchTableFetch(values, 'buyer_journey')
            setIsLoading(true)
        },
    })

    useEffect(() => {
        setTableBody([])
        setIsLoading(true)
        searchTableFetch(formikFetch.values, 'buyer_journey')
    }, [])

    useEffect(() => {
        if (search_fetch_data) {
            if (search_fetch_data.from === 'buyer_journey') {
                setTableBody(
                    search_fetch_data.records.length
                        ? search_fetch_data.records
                        : []
                )
                setIsLoading(false)
            }
        }
    }, [search_fetch_data])

    const tableValues = [
        {
            field: 'users_first_name',
            type: '',
            firstChild: true,
            sort: true,
            disablePadding: false,
            label: 'User First Name',
            filterable: true,
            filter: true,
            filterField: 'u.first_name',
        },
        {
            field: 'users_last_name',
            type: '',
            firstChild: true,
            sort: true,
            disablePadding: false,
            label: 'User Last Name',
            filter: true,
            filterable: true,
            filterField: 'u.last_name',
        },
        {
            field: 'users_email',
            type: '',
            firstChild: true,
            sort: false,
            disablePadding: false,
            label: 'User Email',
            filterable: true,
            filterField: 'u.email',
            filter: true,
        },
        {
            field: 'created_at',
            type: 'datetime',
            firstChild: true,
            disablePadding: false,
            label: 'Created At',
            filterable: true,
            filterField: 'bj.created_at',
            filter: true,
        },
        {
            field: 'description',
            type: '',
            firstChild: true,

            sort: false,
            filterField: 'bj.description',
            disablePadding: true,
            label: 'Description',
            filterable: true,
            // valueOptions: [
            //     { value: 'View Product   ', label: 'View Product' },
            //     { value: 'View BuyNow Cart', label: 'View BuyNow Cart' },
            //     {
            //         value: 'View   All My Bids Page',
            //         label: 'View All My Bids Page',
            //     },
            //     {
            //         value: 'View   Currently Outbid Page',
            //         label: 'View Currently Outbid Page',
            //     },
            //     {
            //         value: 'View   My Bids Winning Page',
            //         label: 'View My Bids Winning Page',
            //     },
            //     {
            //         value: 'User Logged In Successfully',
            //         label: 'User Logged In Successfully',
            //     },
            //     { value: 'View    Page', label: 'View Page' },
            //     { value: 'View   Invoice Page', label: 'View Invoice Page' },
            //     {
            //         value: 'Registered Successfully',
            //         label: 'Registered Successfully',
            //     },
            //     { value: 'View Auction Cart', label: 'View Auction Cart' },
            // ],
        },
        {
            field: 'ip_address',
            type: '',
            firstChild: true,
            sort: false,

            filterField: 'bj.ip_address',
            disablePadding: false,
            label: 'IP Address',
            filterable: true,
        },
        {
            field: 'browser_name',
            type: '',
            firstChild: true,
            sort: false,
            filterField: 'bj.browser_name',
            disablePadding: false,
            label: 'Browser',
            filterable: true,
        },
        {
            field: 'user_location',
            type: '',
            firstChild: true,
            filter: true,
            sort: false,
            filterField: 'bj.user_location',
            disablePadding: false,
            label: 'City',
            filterable: true,
        },
    ]

    const searchInfo = {
        formik: formikFetch,
        data: [
            {
                label: 'First Name',
                placeholder: 'Enter First Name',
                class: 'col-md-4 col-sm-6 col-12',
                type: 'text',
                name: 'users_first_name',
                filter: true,
            },
            {
                label: 'Last Name',
                placeholder: 'Enter Last Name',
                class: 'col-md-4 col-sm-6 col-12',
                type: 'text',
                name: 'users_last_name',
                filter: true,
            },
            {
                label: 'City',
                placeholder: 'Select City',
                class: 'col-md-4 col-sm-6 col-12',
                type: 'text',
                name: 'users_location',
                filter: true,
            },
        ],
    }

    return (
        <Layout>
            <div className="dashboard staticPages">
                <CustomSearch
                    incudeTimelineFilter={true}
                    searchInfo={searchInfo}
                    formik={formikFetch}
                />
                <div className="d-flex justify-content-between align-items-center mt-4"></div>
                <CustomTable
                    formik={formikFetch.values}
                    tableBody={tableBody}
                    tableValues={tableValues}
                    tableActions={[]}
                    allData={search_fetch_data}
                    isLoading={isLoading}
                    loadingTemplate={'table'}
                    changeTableFunction={searchTableFetch}
                    fromVariable={'buyer_journey'}
                />
            </div>
        </Layout>
    )
}

export default CustomerActivity
